import "./enlacesInformativos.css";

const ProblemasAlojamiento = () => {
  return (
    <div className="informacion mx-auto border-0 w-[100%] md:w-[80%] min-h-screen py-[30px] lg:px-0 px-[20px]">
       <h1>Problemas con mi alojamiento</h1>
    
    <section>
        <h2>1. ¿Qué hacer si el alojamiento no cumple con lo prometido?</h2>
        <p>Si al llegar notas que el alojamiento tiene diferencias con la descripción original, sigue estos pasos:</p>
        <ul>
            <li><strong>Contacta al anfitrión:</strong> Explícale el problema y busca una solución directa.</li>
            <li><strong>Documenta la situación:</strong> Toma fotos y guarda evidencia en caso de necesitar respaldo.</li>
            <li><strong>Busca alternativas:</strong> Si el anfitrión no ofrece una solución viable, puedes considerar otras opciones de hospedaje.</li>
            <li><strong>Reporta el caso a la plataforma:</strong> Aunque no gestionamos reembolsos ni disputas, puedes informarnos para que futuros viajeros estén al tanto.</li>
        </ul>
        <p><strong>Importante:</strong> La plataforma no intermedia en reclamos ni devoluciones, ya que la reserva es un acuerdo directo entre el viajero y el anfitrión.</p>
    </section>
    
    <section>
        <h2>2. Problemas comunes y cómo manejarlos</h2>
        <ul>
            <li><strong>El alojamiento está sucio o en mal estado:</strong> Contacta al anfitrión para que pueda solucionar el problema. Si no responde, evalúa alternativas y repórtalo en la plataforma.</li>
            <li><strong>El anfitrión no responde o no está en el check-in:</strong> Revisa si te dejó instrucciones previas. Intenta contactarlo por los medios proporcionados. Si no hay respuesta en un tiempo razonable, considera buscar otra opción y repórtalo en la plataforma.</li>
            <li><strong>Hay servicios que no funcionan (agua, luz, WiFi, calefacción, etc.):</strong> Informa de inmediato al anfitrión. Verifica si hay cortes generales en la zona. Si el problema no se soluciona, puedes optar por buscar otro alojamiento según las condiciones de cancelación.</li>
            <li><strong>Me siento inseguro en el alojamiento:</strong> Si hay un problema de seguridad, aléjate del lugar y contacta a las autoridades locales. Reporta el caso en la plataforma para que revisemos la situación con el anfitrión.</li>
        </ul>
    </section>
    
    <section>
        <h2>3. ¿Qué NO puede hacer la plataforma?</h2>
        <ul>
            <li>No realizamos reembolsos ni compensaciones.</li>
            <li>No garantizamos la resolución de conflictos entre anfitrión y viajero.</li>
            <li>No podemos relocalizar viajeros en caso de inconvenientes.</li>
        </ul>
        <p>Cada viajero es responsable de verificar las condiciones antes de reservar y resolver cualquier inconveniente directamente con el anfitrión.</p>
    </section>
    
    <section>
        <h2>4. ¿Cómo reportar un problema?</h2>
        <p>Si crees que un alojamiento incumple con lo prometido, puedes reportarlo a través de nuestro <strong>Centro de Ayuda</strong> para que tomemos nota y mejoremos la experiencia para futuros viajeros.</p>
    </section>
    </div>
  );
};

export default ProblemasAlojamiento;